export const STORE_LISTINGS_API_URL = 'ui/partner/store_listings';

export const storeListingsQueryKeys = {
  all: [STORE_LISTINGS_API_URL],
  byId: (storeListingId: string) => [
    ...storeListingsQueryKeys.all,
    storeListingId,
  ],
};
